export const DEFAULT_TOOLBAR_CONTROLS = [
  'bold',
  'italic',
  'headlineOne',
  'headlineTwo',
  'headlineThree',
  'headlineFour',
  'headlineFive',
  'headlineSix',
  'xL',
  'unorderedList',
  'orderedList',
  'alignTextLeft',
  'alignTextCenter',
  'alignTextRight',
  'link',
  'sup',
];
